import { Navigate, useLoaderData } from "react-router";
import { EmptyContent } from "@imminently/react/ui/core/empty-content";
import { Text } from "@imminently/react/ui/core/text";

import { encounterService } from "@/services";
import { PatientEncounter } from "@/resources/types";
import { getPatientRoute } from "./patient";

export const getLoadEncounterRoute = (id: string) => `/load-encounter/${id}`;

export const findEncounterLoader = async ({ params }: any) => {
  const { id } = params;
  // We want to find the encounters for the patient by id, sorted by
  // most relevant
  const { data } = await encounterService.getList({
    patient: id,
    sort: { field: "created", order: "desc" },
  });

  return data;
};

export const LoadEncounter = () => {
  const encounters = useLoaderData() as PatientEncounter[];
  console.log("[LoadEncounter] encounters", encounters);

  if (encounters.length === 0) {
    return (
      <EmptyContent width="10rem">
        <Text variant="h1">No patient encounter</Text>
        <Text variant="h4" mt={4}>Looks like this patient has no encounters</Text>
      </EmptyContent>
    );
  }

  return (
    <EmptyContent image="/trier-dark.svg" width="10rem">
      <Text variant="h4" mt={4}>
        {"Loading encounter..."}
      </Text>
      <Navigate to={getPatientRoute(encounters[0].id)} replace={true} />
    </EmptyContent>
  );
};
